import { useEffect, useRef } from 'react'

import { syncCIOInAppRoute } from 'utils/customerio'

// Gist locks a message for 5 seconds after any embed attempt, even one that
// failed because this container hadn't mounted yet, so the mount sync can be
// skipped. Syncing again once that lock expires lets the message embed.
export const RESYNC_AFTER_GIST_LOADING_LOCK_MS = 5500

const CustomerIOInlineContainer = ({
  className,
  elementID,
}: {
  className?: string
  elementID: string
}) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    syncCIOInAppRoute()

    const resyncTimeout = window.setTimeout(() => {
      if (containerRef.current?.childElementCount === 0) {
        syncCIOInAppRoute()
      }
    }, RESYNC_AFTER_GIST_LOADING_LOCK_MS)

    return () => {
      window.clearTimeout(resyncTimeout)
    }
  }, [elementID])

  return (
    <div
      key={elementID}
      ref={containerRef}
      className={className}
      id={elementID}
    />
  )
}

export default CustomerIOInlineContainer
